import 'animate.css/animate.min.css';
import { createBrowserHistory } from 'history';
import React, { lazy, Suspense, useEffect } from 'react';
import { Router } from 'react-router';
import { Route, Switch } from 'react-router-dom';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import './App.css';
import { ErrorModal, Layout } from './components/common';
import PageLoader from './components/common/loader/loader.component';
import { isTMNVerCompatible, isDeviceCompatible } from './utils/helper';

export const history = createBrowserHistory();

export const routes = [
    {
        path: '/',
        component: lazy(() => import('./pages/landing/landing.component')),
    },
    {
        path: '/country',
        component: lazy(() => import('./pages/country/country.component')),
    },
    {
        path: '/transfer',
        component: lazy(() => import('./pages/transfer/transfer.component')),
    },
    {
        path: '/marketing',
        component: lazy(() => import('./pages/marketing/marketing.component')),
    },
    {
        path: '/notify',
        component: lazy(() => import('./pages/notify/notify.component')),
    },
    {
        path: '/tnc',
        component: lazy(() => import('./pages/tnc/tnc.component')),
    },
    {
        path: '/receiver',
        component: lazy(() => import('./pages/receiver-detail/receiver-detail.component')),
    },
    {
        path: '/purpose',
        component: lazy(() => import('./pages/purpose/purpose.component')),
    },
    {
        path: '/location',
        component: lazy(() => import('./pages/location/location.component')),
    },
    {
        path: '/fundinguide',
        component: lazy(() => import('./pages/fundinguide/fundinguide.component')),
    },
    {
        path: '/summary',
        component: lazy(() => import('./pages/summary/summary.component')),
    },
    {
        path: '/error_document_expired',
        component: lazy(() => import('./pages/error/error_document_expired.component')),
    },
    {
        path: '/error_maintenance',
        component: lazy(() => import('./pages/error/error_maintenance.component')),
    },
    {
        path: '/error',
        component: lazy(() => import('./pages/error/error.component')),
    },
    {
        path: '/error_version',
        component: lazy(() => import('./pages/error/error_version.component')),
    },
    {
        path: '/error_insufficient_document',
        component: lazy(() => import('./pages/error/error_insufficient_document.component')),
    },
    {
        path: '/error_update_information',
        component: lazy(() => import('./pages/error/error_update_information.component')),
    },
    {
        path: '/nidinfo',
        component: lazy(() => import('./pages/receiver-nid/nidinfo.component')),
    },
    {
        path: '/nrc_list_view',
        component: lazy(() => import('./pages/receiver-nid/nrc-list-view.component')),
    },
];

const App: React.FC = () => {
    const timeout = { enter: 500, exit: 500 };
    const animationName = 'rag-fadeIn';

    useEffect(() => {
        checkVersion();
    }, [history.location]);

    function checkVersion() {
        if (history.location.pathname === '/error_version') return;
        if (!isTMNVerCompatible()) return history.replace('/error_version?type=tmn_app');
        if (!isDeviceCompatible()) return history.replace('/error_version?type=browser');
    }

    return (
        <Router history={history}>
            <Layout>
                <ErrorModal />
                {/* <TransitionGroup>
                    <CSSTransition timeout={timeout} classNames={animationName} exit={false}></CSSTransition> */}
                <Suspense fallback={<PageLoader />}>
                    <Switch>
                        {routes.map((route) => (
                            <Route key={route.path} exact path={route.path} component={route.component}></Route>
                        ))}
                    </Switch>
                </Suspense>
                {/* </CSSTransition>
                </TransitionGroup> */}
            </Layout>
        </Router>
    );
};

export default App;
